import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminDictionaryCountryCreateRequest {
  @jsonMember(String)
  public label!: string;

  @jsonMember(String)
  public isoCode!: string;

  @jsonMember(Number)
  public position!: number;

  public constructor(
    private readonly data: {
      label: string;
      position: number;
      isoCode: string;
    },
  ) {
    this.label = this.data.label;
    this.position = this.data.position;
    this.isoCode = this.data.isoCode;
  }
}
